import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'app-projects',
  standalone: true,
  imports: [CommonModule, RouterLink],
  templateUrl: './projects.component.html',
  styleUrl: './projects.component.scss'
})
export class ProjectsComponent {
  categories = ['Upcoming', 'Ongoing', 'Completed'];
  projects = projectDetails;
  featuredProjects = this.projects.filter((p: { featured: boolean }) => p.featured);
}

const projectDetails = [
  {
    id: 1,
    title: 'Vastu Udyog',
    location: 'Ajmera, Pune',
    image: 'images/vastu-udyog.jpg',
    category: 'Completed',
    featured: true,
    description: 'A premium residential project in Ajmera.',
    area: '1200 sq.ft',
    budget: '50 Lakh',
    year: 2023
  },
  {
    id: 2,
    title: 'Om Shelter',
    location: 'Dhanori, Pune',
    image: 'images/om-shelter.jpg',
    category: 'Ongoing',
    featured: true,
    description: 'Affordable housing in Dhanori.',
    area: '1000 sq.ft',
    budget: '40 Lakh',
    year: 2024
  },
  {
    id: 3,
    title: 'Mahavir’s Natura',
    location: 'Talegaon, Pune',
    image: 'images/mahavirs-natura.jpg',
    category: 'Upcoming',
    featured: true,
    description: 'Eco-friendly homes in Talegaon.',
    area: '1500 sq.ft',
    budget: '60 Lakh',
    year: 2025
  }
];
